import React, { useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "../../components/common/Button/Button";
import FormInput from "../../components/common/FormInput/FormInput";
import { useNavigate } from "react-router-dom";
import { addAttribute } from "../../api/service/attribute.service";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";


const AddAttribute = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    page_name: "",
    attribute: "",
    value: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.page_name || !form.attribute || !form.value) {
      showToast.error("All fields are required");
      return;
    }

    try {
      setLoading(true);
      const res = await addAttribute(form);

      if (res?.success) {
        showToast.success(res.message || "Attribute added");
        navigate("/attribute");
      }
    } catch (e) {
      showToast.error(e.message || "Failed to add attribute");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-3">
      <div
        className="d-flex align-items-center gap-2 mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}
      >
        <FaArrowLeftLong />
        <h3 className="mb-0 management-tile ml-2">Add Attribute</h3>
      </div>

      <Row>
        <Col md={6} className="mb-3">
          <FormInput
            name="page_name"
            placeholder="Page Name (e.g. About)"
            value={form.page_name}
            onChange={handleChange}
          />
        </Col>

        <Col md={6} className="mb-3">
          <FormInput
            name="attribute"
            placeholder="Attribute (e.g. title_2)"
            value={form.attribute}
            onChange={handleChange}
          />
        </Col>

        <Col md={6} className="mb-3">
          <FormInput
            name="value"
            placeholder="Value"
            value={form.value}
            onChange={handleChange}
          />
        </Col>

        <Col xs={12}>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Add Attribute"}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default AddAttribute;
